/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusAdvanceDto
 */
export interface NovitusAdvanceDto {
    /**
     * Nazwa towaru/usługi która jest sprzedawana w trakcie transakcji. Nazwa towaru ma szczególne własności, podczas sprzedaży. Drukarka fiskalna dokonuje wyznaczenia nazwy fiskalnej która to ignoruje wielkości liter oraz spacje i większość znaków specjalnych. Nazwa fiskalna w połączeniu ze stawką podatkową muszą zachować się tak, aby spełniać zasadę schodka podatkowego. Obniżać stawki można dowoli, podwyższać również, obniżać po podwyższeniu, natomiast po obniżeniu nie wolno podwyższyć stawki PTU. Pomimo wyznaczenia nazwy fiskalnej na fakturze jest drukowana 'Nazwa towaru/usługi'.
     * @type {string}
     * @memberof NovitusAdvanceDto
     */
    description: string;
    /**
     * Symbol stawki podatkowej może przyjąć wartości stawek od A do G.
     * @type {string}
     * @memberof NovitusAdvanceDto
     */
    ptu: NovitusAdvanceDtoPtuEnum;
    /**
     * Wartość zaliczki.
     * @type {string}
     * @memberof NovitusAdvanceDto
     */
    value: string;
}


/**
 * @export
 */
export const NovitusAdvanceDtoPtuEnum = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G'
} as const;
export type NovitusAdvanceDtoPtuEnum = typeof NovitusAdvanceDtoPtuEnum[keyof typeof NovitusAdvanceDtoPtuEnum];


/**
 * Check if a given object implements the NovitusAdvanceDto interface.
 */
export function instanceOfNovitusAdvanceDto(value: object): value is NovitusAdvanceDto {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('ptu' in value) || value['ptu'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusAdvanceDtoFromJSON(json: any): NovitusAdvanceDto {
    return NovitusAdvanceDtoFromJSONTyped(json, false);
}

export function NovitusAdvanceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusAdvanceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'ptu': json['ptu'],
        'value': json['value'],
    };
}

export function NovitusAdvanceDtoToJSON(value?: NovitusAdvanceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'ptu': value['ptu'],
        'value': value['value'],
    };
}

